import React from 'react'
import {TextField, Section} from 'jbc-front/components/Form'
import {reduxForm} from 'redux-form'
import Button from 'jbc-front/components/Button'
import FormErrors, {onSubmitFail} from 'jbc-front/components/FormErrors'
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import api from 'api'
import {getState} from 'utils'
import {notifySuccess} from 'store/actions/notify'
import {asyncError} from 'store/actions/asyncError'

const validate = (values) => {
  const errors = {}
  if (values.password && values.password_confirmation && values.password !== values.password_confirmation) {
    errors.user_password_confirmation = 'が一致しません'
  }
  return errors
}

const ChangePasswordForm = reduxForm({
  form: 'change_password',
  onSubmitFail,
  validate,
})(({submitting, handleSubmit}) => (
  <form onSubmit={handleSubmit}>
    <div className="l-title-wrap">
      <h1 className="m-title-main">パスワード変更</h1>
    </div>
    <div className="basic_information">
      <FormErrors />
      <Section>
        <TextField name="old_password" label="旧パスワード" type="password" required />
        <TextField name="password" label="新パスワード" type="password" required />
        <TextField name="password_confirmation" label="新パスワード(確認用)" type="password" required />
      </Section>
      <div className="u-ta-c u-mt30">
        <Button as="button" primary type="submit" disabled={submitting}>
          変更
        </Button>
      </div>
    </div>
  </form>
))

const ChangePassword = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const onSubmit = async (values) => {
    const state = await getState(dispatch)
    const token = state.auth.token
    try {
      await api.createWithAuth(token).changePassword(values)
      dispatch(notifySuccess('変更しました'))
      history.push('/account_settings/account')
    } catch (err) {
      dispatch(asyncError(err))
    }
  }
  return <ChangePasswordForm onSubmit={onSubmit} />
}

export default ChangePassword
